export default __webpack_public_path__ + "6bc0664af788087de0b76e41911538ae.png";